import { Controller } from "stimulus";
import { trackEvent } from "../../analytics";
import { SELECT_API_SUBSCRIBE_CTA } from "../../mixpanel_config";

export default class extends Controller {
  static targets = [
    "annualPlans",
    "monthlyPlans",
    "monthlyText",
    "annualText",
    "monthlyTable",
    "annualTable",
    "toggle"
  ];

  connect() {
    this.subscriptionPlanIdentifier = null;
    this.subscriptionPlanDuration = null;
  }

  toggle() {
    // TODO: Remove else clause after Premium pricing page is V2.
    if (this.monthlyTextTarget.classList.contains("tw-opacity-50") || this.annualTextTarget.classList.contains("tw-opacity-50")) {
      this.monthlyPlansTarget.classList.toggle("tw-hidden", this.toggleTarget.checked);
      this.monthlyTextTarget.classList.toggle("tw-opacity-50", this.toggleTarget.checked);
      this.monthlyTableTarget.classList.toggle("tw-hidden", this.toggleTarget.checked);

      this.annualPlansTarget.classList.toggle("tw-hidden", !this.toggleTarget.checked);
      this.annualTextTarget.classList.toggle("tw-opacity-50", !this.toggleTarget.checked);
      this.annualTableTarget.classList.toggle("tw-hidden", !this.toggleTarget.checked);
    } else {
      this.monthlyPlansTarget.classList.toggle("premium-card--active");
      this.annualPlansTarget.classList.toggle("premium-card--active");
      this._toggleText(this.monthlyTextTarget);
      this._toggleText(this.annualTextTarget);
    }
  }

  analyticsApiSubscribeCta(e) {
    this.subscriptionPlanIdentifier = this._parsePlanIdentifier(e.currentTarget.dataset.planIdentifier);
    this.subscriptionPlanDuration = this.monthlyPlansTarget.classList.contains("tw-hidden") ? "yearly" : "monthly"

    trackEvent(SELECT_API_SUBSCRIBE_CTA, { plan_type: this.subscriptionPlanIdentifier, plan_duration: this.subscriptionPlanDuration })
  }

  _parsePlanIdentifier(planIdentifier) {
    switch (planIdentifier) {
      case "analyst":
        return "api_analyst"
      case "lite":
        return "api_lite"
      case "self_serve_pro":
        return "api_pro"
    }
  }

  _toggleText(element) {
    if (element.classList.contains("tw-text-gray-400")) {
      element.classList.remove("tw-text-gray-400");
      element.classList.add(
        "tw-text-gray-600",
        "dark:tw-text-gray-300",
        "tw-font-bold",
      );
    } else {
      element.classList.remove(
        "tw-text-gray-600",
        "dark:tw-text-gray-300",
        "tw-font-bold",
      );
      element.classList.add("tw-text-gray-400");
    }
  }
}
